<template>
  <v-layout style="margin-bottom: 65px">
    <v-app-bar elevation="0" class="border-b px-4">
      <v-toolbar-title @click="navigateTo('/pembelajaran-wajib')">
        <v-img height="48px" width="106px" src="/images/logo.png"
      /></v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="$route.fullPath !== '/maintenance?page=GENERAL'">
        <template v-if="$vuetify.display.mdAndUp">
          <AccountBelajarWajib />
          <v-menu width="254">
            <template v-slot:activator="{ props }">
              <v-btn
                icon="mdi-chevron-down"
                variant="text"
                v-bind="props"
              ></v-btn>
            </template>
            <v-list>
              <v-list-item title="Keluar" @click="logoutBelajarWajib">
                <template v-slot:prepend>
                  <v-icon icon="mdi-logout"></v-icon>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <v-menu v-else width="254">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-dots-vertical"
              variant="text"
              v-bind="props"
            ></v-btn>
          </template>
          <v-list>
            <AccountBelajarWajib class="mb-2" />
            <v-divider></v-divider>
            <v-list-item title="Keluar" @click="logoutBelajarWajib">
              <template v-slot:prepend>
                <v-icon icon="mdi-logout"></v-icon>
              </template>
            </v-list-item>
          </v-list> </v-menu
      ></template>
    </v-app-bar>
  </v-layout>
  <NuxtPage />
</template>
<script>
import AccountBelajarWajib from "~/components/pembelajaran_wajib/shared/AccountBelajarWajib";

export default {
  components: {
    AccountBelajarWajib,
  },
  methods: {
    logoutBelajarWajib() {
      useBelajarWajibStore().clearTokens();
      return navigateTo({ path: "/pembelajaran-wajib/login" });
    },
  },
};
</script>
